import type { ShopMetaByKeyQueryResponse } from '~/api/graphql/queries/shopMetaByKey.generated';

export const parseShopMeta = (data: ShopMetaByKeyQueryResponse) => {
  return data?.shopMetaByKey?.value ? JSON.parse(data.shopMetaByKey.value) : {};
};
